import { render } from "./PerformanceProductTable.vue?vue&type=template&id=3f098132"
import script from "./PerformanceProductTable.vue?vue&type=script&lang=js"
export * from "./PerformanceProductTable.vue?vue&type=script&lang=js"

import "./PerformanceProductTable.vue?vue&type=style&index=0&id=3f098132&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__